// removed by extract-text-webpack-plugin
module.exports = {"container":"_6koXyWUiyZifUCvacWMad","photoContainer":"_3Lkm_Ve-tefxzCwquTq6zn","changeLabel":"mFoKXO5ARshFF5fC000xx","photo":"_340pJK9ieyz0lOhNrC2gIG","avatar":"pSIEVUq-Gspn6uHLtQ2mc","fileInput":"_1wkbRMe4EWEcqEau05qKdW","info":"_34zt32AtTohR0YJqceJ1ap","fioContainer":"tytTR64nY0abRFwYZm7rv","name":"_3y0g_3CBvgdXGkkXknRyqn","email":"_2CffJDDiWkN4dyOWZO-tlI","company":"_19FHJTt3-FPHSIsn0TII8i","controls":"_3C-w6TYW4ZHuh5aqh--wBB","editBtn":"_3rLwkjndxlKP8Z9pm4xhdd"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Users/UserPage/UserInfo/UserInfo.pcss
// module id = 1359
// module chunks = 0